import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.medical-data-confidentiality': {
         confidentialAccessPending: 'Wysłano prośbę o dostęp',
         confidentialAccessRequest: 'Poproś o dostęp',
         confidentialAccessRequestSuccess: 'Prośba o dostęp do zasobu poufnego została wysłana.',
         confidentialAccessSelfGrantSuccess: 'Dostęp do zasobu poufnego został przyznany.',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.medical-data-confidentiality'
);
